import { useEffect, useState } from "react"
import { Button, Row, Col, FloatingLabel, FormControl, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Spinner } from "react-bootstrap";
import PrivateApi from "../../../services/PrivateApiService";

const FeedbackModal = ({ show, setShow }) => {

    const API = new PrivateApi();
    const [view, setView] = useState("form");
    const [message, setMessage] = useState("");
    const [isInvalid, setIsInvalid] = useState(false);

    useEffect(() => {
        if (show === true) setView("form")
    }, [show])

    const sendBtnHandler = () => {
        if (message === "" || message.length < 4) return setIsInvalid(true);

        setView("loading");

        API.feedback_post({message: message})
            .then(() => setView("done"));
    }

    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <ModalHeader closeButton={view !== "loading"}>
                <ModalTitle>Feedback</ModalTitle>
            </ModalHeader>
            <ModalBody>
                {
                    view === "form"?
                        <>
                            <p className="text-muted">
                                Bitte hinterlassen Sie hier Ihr Feedback bzw.
                                Ihre Verbesserungsvorschläge. Wir werden
                                versuchen, diese in den nächsten Versionen zu
                                berücksichtigen. Danke für Ihr Interesse!
                            </p>
                            <Row>
                                <Col>
                                    <FloatingLabel label="Nachricht">
                                        <FormControl
                                            as="textarea"
                                            placeholder="Nachricht"
                                            style={{height: 100}}
                                            value={message}
                                            onChange={e => setMessage(e.target.value)}
                                            isInvalid={isInvalid}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                        </> :

                    view === "loading" ?
                        <div className="text-center mt-3 mb-3">
                            <Spinner animation="border" className="text-energo" /> 
                        </div> : 

                    view === "done" ?
                        <>
                            <p className="text-muted">Ihr Feedback ist bei uns eingegangen. Vielen Dank für Ihr Mitwirken!</p>
                        </> :
                    null
                
                }
            </ModalBody>
            <ModalFooter hidden={view === "loading"}>
                {view === "form" &&
                    <div className="d-flex gap-2">
                        <Button onClick={() => setShow(false)} variant="warning">Abbrechen</Button>
                        <Button onClick={() => sendBtnHandler()} variant="energo">Absenden</Button>
                    </div>
                }
                <div hidden={view !== "done"}>
                    <Button onClick={() => setShow(false)} variant="energo">Schließen</Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}
export default FeedbackModal;